<template>
  <div>
    <v-dialog width="600px" v-model="showChangePassword" persistent>
      <template v-slot:activator="{ on }">
        <v-btn depressed outline small color="primary" v-on="on">
          {{ $t('Change Password') }}
        </v-btn>
      </template>
      <v-card v-if="showChangePassword" class="pa-3">
        <v-card-text>
          <form class="form-control" :class="{ 'has-error': errors.has('password') }">
            <label>New password</label>
            <v-text-field
              solo
              flat
              outline
              name="password"
              v-validate="'required'"
              v-model.trim="password"
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
              :type="showPassword ? 'text' : 'password'"
              :data-vv-as="'Password'"
              :placeholder="'Password'"
              ref="password"
              class="custom-password-input"
              @click:append="showPassword = !showPassword"
              @input="onCheckPasswordPattern"
              @focus="showPasswordCondition = true"
              hide-details
            ></v-text-field>
            <span class="text-error" v-if="errors.has('password')">{{
              errors.first('password')
            }}</span>
            <div
              v-if="showPasswordCondition"
              class="pa-3 mb-3"
              style="background-color: #ebebeb; font-size: 14px"
            >
              <div class="d-flex">
                <h6 class="mb-2">Password must :</h6>
                <div class="text-xs-right">
                  <v-btn icon ripple @click="showPasswordCondition = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </div>
              </div>
              <div class="pb-1">
                <v-icon v-if="!password_pattern.has_minimum_length">circle</v-icon>
                <v-icon color="primary" v-else>check_circle</v-icon>
                <span class="pl-1">Be at least 8 characters</span>
              </div>
              <div class="pb-1">
                <v-icon v-if="!password_pattern.has_uppercase">circle</v-icon>
                <v-icon color="primary" v-else>check_circle</v-icon>
                <span class="pl-1">Have at least one upper case character</span>
              </div>
              <div class="pb-1">
                <v-icon v-if="!password_pattern.has_lowercase">circle</v-icon>
                <v-icon color="primary" v-else>check_circle</v-icon>
                <span class="pl-1">Have at least one lower case character</span>
              </div>
              <div class="pb-1">
                <v-icon v-if="!password_pattern.has_number">circle</v-icon>
                <v-icon color="primary" v-else>check_circle</v-icon>
                <span class="pl-1">Have at least one number</span>
              </div>
              <div class="pb-1">
                <v-icon v-if="!password_pattern.has_special">circle</v-icon>
                <v-icon color="primary" v-else>check_circle</v-icon>
                <span class="pl-1">Have at least one special character(! @ # % ^ & * ? . ,)</span>
              </div>
            </div>
          </form>

          <form class="form-control my-2" :class="{ 'has-error': errors.has('passwordconfirm') }">
            <label>Confirm password</label>
            <v-text-field
              solo
              flat
              outline
              name="passwordconfirm"
              v-validate="'required|confirmed:password'"
              v-model.trim="confirmpassword"
              type="password"
              :data-vv-as="'Confirm password'"
              :placeholder="'Confirm password'"
              class="custom-password-input"
              hide-details
            ></v-text-field>
            <span class="text-error" v-if="errors.has('passwordconfirm')">{{
              errors.first('passwordconfirm')
            }}</span>
          </form>
          <div class="text-xs-center">
            <v-btn @click="cancel" outline color="grey">Cancel</v-btn>
            <v-btn
              @click="onSubmit"
              :loading="loading"
              :disabled="loading"
              depressed
              color="primary"
              >Save</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import hopinnHrApi from '@/api/hopinn-hr'

export default {
  props: ['value'],
  data() {
    return {
      showChangePassword: false,
      loading: false,
      password: '',
      confirmpassword: '',
      showPassword: false,
      password_pattern: {
        has_minimum_length: false,
        has_lowercase: false,
        has_uppercase: false,
        has_number: false,
        has_special: false,
        has_pass_condition: false
      },
      showPasswordCondition: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    onCheckPasswordPattern() {
      let password_pattern = this.password_pattern
      password_pattern.has_minimum_length = this.password.length >= 8
      password_pattern.has_number = /\d/.test(this.password)
      password_pattern.has_lowercase = /[a-z]/.test(this.password)
      password_pattern.has_uppercase = /[A-Z]/.test(this.password)
      password_pattern.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(this.password)

      let validPassword = Object.keys(password_pattern).filter(function (key) {
        return password_pattern[key] == true
      })

      this.password_pattern.has_pass_condition = validPassword.length >= 5
    },
    toggleMarker() {
      this.marker = !this.marker
    },
    cancel() {
      this.password = ''
      this.confirmpassword = ''
      this.password_pattern = {
        has_minimum_length: false,
        has_lowercase: false,
        has_uppercase: false,
        has_number: false,
        has_special: false,
        has_pass_condition: false
      }
      this.showPasswordCondition = false
      this.showChangePassword = false
    },
    onSubmit() {
      const vm = this
      vm.loading = true
      vm.$validator.validate().then((result) => {
        if (!result) {
          vm.loading = false
          return false
        }

        if (!vm.password_pattern.has_pass_condition) {
          vm.$swal.fire({
            type: 'error',
            text: 'Invalid password format',
            confirmButtonColor: '#3D1A6E'
          })
          vm.loading = false
          return false
        }

        vm.submitChangePassword()
      })
    },
    async submitChangePassword() {
      const vm = this
      try {
        const staffid = vm.value
        let data = {
          pageid: vm.selectedBot.pageid,
          staffid: staffid,
          newPassword: vm.password
        }
        const response = await hopinnHrApi.changePassword({ data })
        vm.loading = false
        if (response && response.data.responsecode == 200) {
          vm.cancel()
          await vm.$swal.fire({
            text: 'เปลี่ยนรหัสผ่านสำเร็จ',
            type: 'success'
          })
          vm.$emit('success')
        }
      } catch (error) {
        console.error(error)
        return
      }
    }
  }
}
</script>

<style lang="scss">
.form-control.has-error .custom-password-input {
  input[type='password'] {
    border: none !important;
  }
}

.custom-password-input {
  input[type='text'],
  input[type='number'],
  input[type='password'],
  input[type='url'] {
    border: 0;
    width: 100%;
    padding: 0px 0px;
    margin: 0px 0 0px;
    box-sizing: border-box;
    box-shadow: none !important;
    padding: 8px 0 8px;

    &:hover,
    &:focus,
    &:active {
      border: 0 !important;
      box-shadow: none !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/HopinnHr/ChangePassword.vue